const initialState = {
    listMoreProducts: {},
};
const moreProducts = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_LIST_MORE_PRODUCTS':
            return {...state, listMoreProducts:  action.listMoreProducts};
        default:
            return state;
    }
};

export default moreProducts;